import { useTranslation, useProperty, useSiteContext } from '@eti/providers';
import { useRef } from 'react';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import { CANCELLATION_INSURANCE_COVER_GENIUS } from '../../products';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import { concatenateCoverGeniusTexts } from '../../common/utils/coverGeniusApiTexts';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useIllustration } from '../../common/utils/useIllustration';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import { getPriceProps, getReadMoreLabel, getSingleChoiceProps, getUpsellProps } from '../../common/utils/productCardProps';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CANCELLATION_INSURANCE_COVER_GENIUS;
export const texts = {
  abstractContent: 'cancellationInsuranceCoverGeniusAbstractText',
  readMoreContent: 'cancellationInsuranceCoverGeniusAdditionalInformation',
  title: 'cancellationInsuranceCoverGeniusTitle',
  upSell: 'cancellationInsuranceCoverGeniusUpSellText',
  IpidPolicyLinkText: 'coverGeniusIPIDPolicyLinkText',
  policyLinkText: 'coverGeniusPolicyLinkText'
};
const MainCancellationInsuranceCoverGenius = _ref => {
  let {
    className,
    form,
    isSelected,
    order,
    sellSpecification,
    productPosition,
    productSpecificTexts
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const {
    market
  } = useSiteContext();
  const isInUSMarket = market.code === 'US';
  const isInUKMarket = market.code === 'GB';
  const {
    p
  } = useProperty();
  const illustrationUrl = useIllustration(PRODUCT_NAME);
  const rootElement = useRef(null);
  useProductSnowplowTracking(PRODUCT_NAME, {
    rootElement,
    productPosition
  });
  const translatedTexts = getTranslatedTexts(texts, t);
  const {
    abstractContent,
    readMoreContent,
    title,
    upSell,
    IpidPolicyLinkText,
    policyLinkText
  } = translatedTexts;
  const {
    disclaimer,
    ipid,
    termsUrl = ''
  } = productSpecificTexts || {};
  const product = getProduct(PRODUCT_ID, order, 'none');
  if (!product) {
    return null;
  }
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(upSell);
  const {
    priceRaw
  } = product;
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSelected, product);
  const readMoreButtonLabel = getReadMoreLabel(t);
  const terms = {
    url: termsUrl,
    text: policyLinkText
  };
  const ipidPolicy = {
    url: ipid === null || ipid === void 0 ? void 0 : ipid.url,
    text: IpidPolicyLinkText
  };
  const additionalInformationCoverGenius = concatenateCoverGeniusTexts({
    disclaimer: isInUSMarket ? disclaimer : undefined,
    ipidPolicy: isInUKMarket || isInUSMarket ? ipidPolicy : undefined,
    terms: isInUKMarket || isInUSMarket ? terms : undefined,
    isInUSOrUKMarket: isInUSMarket || isInUKMarket
  });
  const readMoreContentCoverGenius = concatenateCoverGeniusTexts({
    ipidPolicy: !(isInUKMarket || isInUSMarket) ? ipidPolicy : undefined,
    terms: !(isInUKMarket || isInUSMarket) ? terms : undefined,
    disclaimer: !isInUSMarket ? disclaimer : undefined
  });
  const extraProps = getSingleChoiceProps(t, p, nonDebugT);
  const productData = {
    additionalInformation: additionalInformationCoverGenius,
    className,
    extraProps,
    description: abstractContent,
    form,
    illustrationUrl,
    isHighlighted: isUpsellHighlight,
    isSelected,
    price,
    priceLabel,
    priceRaw,
    priceSuffix,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    readMoreButtonLabel,
    readMoreContent: readMoreContent + readMoreContentCoverGenius,
    sellSpecification,
    shouldDisplayUpsell,
    title,
    upSell: upSellObject
  };
  return /*#__PURE__*/_jsx(ProductLayout, {
    productData: productData,
    ref: rootElement
  });
};
export default MainCancellationInsuranceCoverGenius;
//# sourceMappingURL=MainCancellationInsuranceCoverGenius.js.map